import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import Icon, { GLYPHS } from '../../../../../common/icon';
import { t } from '../../../../../../modules/infra/i18n';

const CustomerNoMembership = props => (
  <div className="c-customer-no-membership">
    <div className="o-flexbox o-flexbox--content-align-center">
      <div className="c-customer-no-membership-icon u-mr-">
        <Icon glyph={GLYPHS.identityCard} />
      </div>
      <div className="u-co-dark-gray">{t('customers:form.membership.no_active_membership')}</div>
    </div>
    <Link
      className="c-btn"
      to={{
        pathname: '/register',
        state: { customer: props.customer, openNewMembershipSale: true },
      }}
      display-if={props.canSellMembership}
    >
      <span className="c-btn__text">{t('customers:form.membership.sell_membership_button')}</span>
    </Link>
  </div>
);

CustomerNoMembership.propTypes = {
  canSellMembership: PropTypes.bool.isRequired,
  customer: PropTypes.object.isRequired,
};

export default CustomerNoMembership;
